import instance from "../apis/app";


const Recintos = {
  // Listar todos los recintos
  List: async (params = {}) => {
    try {
      const response = await instance.get('/recintos', { params });
      return response;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Obtener un recinto por ID
  GetById: async (id) => {
    try {
      const response = await instance.get(`/recintos/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Crear un recinto
  Create: async (data) => {
    try {
      const response = await instance.post('/recintos', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Actualizar un recinto
  Update: async (id, data) => {
    try {
      const response = await instance.put(`/recintos/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Eliminar un recinto
  Delete: async (id) => {
    try {
      const response = await instance.delete(`/recintos/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Cambiar estado (activo/inactivo)
  CambiarEstado: async (id, estado) => {
    try {
      const response = await instance.patch(`/recintos/${id}/estado`, { estado });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  GetTalleres: async (id, estado = null) => {
    try {
      const params = {};
      if (estado) params.estado = estado;
      const response = await instance.get(`/recintos/${id}/talleres`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default Recintos;
